import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿En qué formato recibo el material?',
    answer: 'Recibís todo en formato PDF de alta calidad, listo para imprimir en casa o en una gráfica, o para verlo directamente desde tu celular o tablet.'
  }, {
    question: '¿Para qué edades sirve?',
    answer: 'Es ideal para chicos y chicas de 3 a 17 años. Las actividades son súper adaptables a todas las etapas del desarrollo.'
  }, {
    question: '¿Hay que gastar mucho dinero para hacer las citas?',
    answer: '¡No! El 90% de las citas son gratuitas o muy económicas. Están pensadas para usar cosas que ya tenés en casa o hacer actividades al aire libre.'
  }, {
    question: '¿Qué pasa si una cita no me gusta o no aplica a mi familia?',
    answer: 'Con los bonos incluidos, tenés más de 400 opciones en total para elegir la que mejor vaya con ustedes. ¡Siempre vas a encontrar una que les encante!'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-10 bg-white pb-24" data-id="element-46" data-mp="20ouj6qi7tayl">
      <div className="container mx-auto px-4" data-id="element-47" data-mp="20o2m1b8yz567">
        <FadeIn data-id="element-48" data-mp="2fdqmybd8o1te">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-slate-900 mb-8" data-id="element-49" data-mp="2fd8t1le1tzon">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="max-w-3xl mx-auto space-y-3" data-id="element-50" data-mp="2aedxrjywainn">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-51" data-mp="2odnfio2r1ktq" data-mpi={index}>
              <div className="border border-slate-200 rounded-xl overflow-hidden bg-slate-50" data-id="element-52" data-mp="2jetzanw2vfpv">
                <button onClick={() => toggleAccordion(index)} className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-53" data-mp="tzvz95px02pb">
                  <span className="font-bold text-slate-900 text-lg pr-4" data-id="element-54" data-mp="2p4dkg87i4z8a">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-500 transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-55" data-mp="2u2x76atx6f1p" />
                </button>
                <div className={`px-5 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-56" data-mp="3310g87npxjcm">
                  <p className="text-slate-600 text-base" data-id="element-57" data-mp="3hs9cv0q1g4z9">{faq.answer}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}